// export const baseURL = process.env.NODE_ENV === 'development' ? 'http://121.40.31.114:9999' : 'http://gateway.c67942520e73c4603b78ba4800005e3c4.cn-hangzhou.alicontainer.com'
export const baseURL =
  process.env.NODE_ENV === 'development'
    ? 'http://121.40.31.114:9999'
    : 'http://gateway.c67942520e73c4603b78ba4800005e3c4.cn-hangzhou.alicontainer.com'
